import { render } from "./OnboardGuestView.vue?vue&type=template&id=491aa08d&scoped=true"
import script from "./OnboardGuestView.vue?vue&type=script&lang=js"
export * from "./OnboardGuestView.vue?vue&type=script&lang=js"

import "./OnboardGuestView.vue?vue&type=style&index=0&id=491aa08d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491aa08d"]])

export default __exports__